var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-holder"},[_c('div',{staticClass:"close-holder"},[_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function($event){return _vm.close()}}})]),_c('div',{staticClass:"panel",on:{"click":_vm.handleClick}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }